const DEFAULT_SORT_LANGUAGE = 'is';

const collatorsByLanguage = new Map<string, Intl.Collator>();

function getCollator(language: string) {
  let collator = collatorsByLanguage.get(language);
  if (!collator) {
    collator = new Intl.Collator(language, { sensitivity: 'accent', numeric: true });
    collatorsByLanguage.set(language, collator);
  }
  return collator;
}

export function compareStrings(
  a: string,
  b: string,
  ascending = true,
  language = DEFAULT_SORT_LANGUAGE,
) {
  const collator = getCollator(language);
  if (ascending) {
    return collator.compare(a, b);
  }
  return collator.compare(b, a);
}

export function sortStrings(values: string[]): string[] {
  return [...values].sort((left, right) => {
    return compareStrings(left, right);
  });
}
